import { connect } from 'react-redux';
import Modal from 'comp/modals/map';
import * as selectors from 'selectors';

const mapToProps = state => ({
  conv_id: selectors.getSelectedConvId(),
  tmp_pm: state.ui.tmp_pm
});

export default connect(mapToProps)(Modal);



// WEBPACK FOOTER //
// ./src/containers/modals/Map.js